module.exports = __webpack_public_path__ + "static/media/40328331_left.44973973.usdz";